import React, { Component, Fragment } from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import '../../assets/style/itemStyle/common.scss';
import { infoEmail } from '../../untils/constant/email';
export default class TermOfUse extends Component {
  render() {
    return (
      <Fragment>
        <HeaderMeta type="termOfUse" jsonLd={[buildPageBreadcrumb('Terms of Use', '/termOfUse')]} />
        <div className="term-of-use-content">
          <h1
            style={{
              textDecoration: 'underline',
              display: 'flex',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '700',
            }}
          >
            Terms and Conditions
          </h1>
          <br />
          <br />
          <b>Last Updated: September 19, 2022</b>
          <br />
          <br />
          This website is operated by Airacer Inc., (hereinafter, “<b>Airacer</b>”, “<b>We</b>”, or
          “<b>Us</b>”). These terms and conditions (the “<b>Terms</b>”) govern your access to the
          Airacer website{' '}
          <a
            href="https://airacer.com"
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
          >
            https://airacer.com
          </a>{' '}
          and any other mobile applications, web services owned, controlled, or offered by Airacer,
          now or in the future (all collectively referred to as, the “<b>Services</b>”). The term “
          <b>You</b>” or “<b>User</b>” shall refer to any individual that views, uses, accesses,
          browses or submits any content or material to the Services. Independent businesses who
          operate through the Services, may also be referred as “<b>Merchant</b>.”
          <br />
          <br />
          These Terms are important and affect your legal rights, so please read them carefully.
          Note that these Terms contain a{' '}
          <b style={{ textDecoration: 'underline' }}>mandatory arbitration provision</b> that
          requires the use of arbitration on an individual basis and limits the remedies available
          to you in the event of certain disputes.
          <br />
          <br />
          The Services are offered to you conditioned on your acceptance without modification of
          Terms contained herein. Certain features, services or tools of the Services may be subject
          to additional guidelines, terms, or rules, which will be posted with those features and
          are a part of these Terms. Your use of the Services constitutes your agreement to all such
          Terms. Please read these terms carefully and keep a copy of them for your reference.
          <br />
          <br />
          <b>
            YOU ACKNOWLEDGE AND AGREE THAT BY ACCESSING, USING, CONSUMMATING A FINANCIAL
            TRANSACTION, OR BROWSING THE SERVICES, YOU ARE AFFIRMING THAT YOU HAVE READ, UNDERSTAND
            AND AGREE TO BE BOUND BY THESE TERMS, WHETHER OR NOT YOU HAVE REGISTERED WITH THE
            SERVICES. IF YOU DO NOT AGREE TO THESE TERMS, THEN YOU HAVE NO RIGHT TO ACCESS OR USE
            THE SERVICES.
          </b>
          <br />
          <br />
          <b>PRIVACY POLICY</b>
          <br />
          Your use of the Services is subject to the Airacer Privacy Policy. Please review our{' '}
          <a
            href="/privacyPolicy"
            target="_blank"
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
          >
            Privacy Policy
          </a>
          , which also governs the Services and informs Users of our data collection practices.
          <br />
          <br />
          1. <b>&nbsp; USE OF OUR SERVICES</b>
          <br />
          <br />
          Airacer is a platform that offers is users the ability to book aviation experiences,
          training flights and chartered flights from different flight providers in different
          locations around the United States.
          <br />
          <br />
          Subject to your compliance with its obligations under these Terms, we will provide you
          with access to the Services. Access to the Services is permitted on a temporary basis, and
          we reserve the right to withdraw or amend the service we provide without notice. We will
          not be liable if for any reason our Services are unavailable at any time or for any
          period.
          <br />
          <br />
          You must be eighteen (18) years or over in order to use the Services.
          <br />
          <br />
          2.<b> &nbsp; REGISTRATION, ACCOUNT AND COMMUNICATION PREFERENCES</b>
          <br />
          <br />
          In order to access and use certain areas or features of the Services, you may need to have
          an account with us (the “<b>Account</b>”). We may maintain different types of Accounts for
          different types of Users. If you create an Account on behalf of a company, organization,
          or other entity, then (i) “you” includes you and that entity; (ii) you represent and
          warrant that you are an authorized representative of the entity with authority to bind the
          entity to these Terms; and (iii) you agree to these Terms on the entity’s behalf. By
          creating an Account, you agree to (i) provide accurate, current and complete account
          information about yourself as necessary, (ii) maintain and promptly update from time to
          time as necessary your Account information, (iii) maintain the security of your password
          and accept all risks of unauthorized access to your Account and the information you
          provide to Us, and (iv) immediately notify Us if you discover or otherwise suspect any
          security breaches related to your Account. In creating an Account, you represent that you
          are of legal age to form a binding contract and are not a person barred from receiving
          services under the laws of the United States or any other applicable jurisdiction. We
          reserve the right to suspend or terminate your Account if any information provided during
          the registration process or thereafter proves to be inaccurate, false or misleading.
          <br />
          <br />
          (a) <b>Communication Preferences.</b> By creating an Account, you also consent to receive
          electronic communications from Us (e.g., via email or by posting notices to the Services).
          These communications may include notices about your Account (e.g., password changes,
          updates and other transactional information) and are part of your relationship with Us.
          You agree that any notices, agreements, disclosures or other communications that we send
          to you electronically will satisfy any legal communication requirements, including, but
          not limited to, that such communications be in writing.
          <br />
          <br />
          (b) <b>Account Information; Updates.</b> You agree to provide current, complete and
          accurate payment and account information for your Account. You promise to update the
          information you have provided to Airacer in the event of any changes to your driving
          record, contact information, or background. Specifically, with respect to your contact
          information, Airacer may deliver notices to you at the most recent email, telephone, or
          address provided by you, and those notices will be considered valid even if you no longer
          maintain the email account, telephone number, or receive mail at that address unless you
          provide updated contact information to us. <br />
          <br />
          (c) <b>Account Access and Security.</b> Also, you are, and will be solely responsible for,
          all of the activity that occurs through your Account, so please keep your password and
          Airacer Account information secure. You agree that you will not disclose your password to
          any third party and that you will take sole responsibility for any activities or actions
          under your Airacer Account, whether or not you have authorized such activities or actions.
          You will immediately notify Airacer of any actual or suspected unauthorized use of your
          Airacer Account. We are not responsible for your failure to comply with this clause, or
          for any delay in shutting down or protecting your Airacer Account after you have reported
          unauthorized access to us. We reserve the right to suspend the provision of the Services
          or any part thereof, if any information provided during the registration process or
          thereafter proves to be inaccurate, false or misleading. You are responsible for all
          charges incurred under your Account, whether made by you or another person using your
          Account. You may not assign or otherwise transfer your Account to any other person or
          entity. You acknowledge that we are not responsible for third party access to your account
          that results from theft or misappropriation of your account. We reserve the right to
          refuse or cancel service, terminate accounts, or remove or edit content from the Services
          if in our opinion, you have failed to comply with any of the provisions of these Terms.{' '}
          <br />
          <br />
          3. <b> &nbsp; ACCESS TO THE SERVICES</b>
          <br />
          <br />
          We shall use commercially reasonable efforts to ensure the availability of the Services,
          except that we shall not be liable for: (a) scheduled downtime; or (b) any unavailability
          caused directly or indirectly by circumstances beyond our reasonable control, including
          without limitation, (i) a force majeure event; (ii) Internet Host, webhosting, cloud
          computing platform, or public telecommunications network failures or delays, or denial of
          service attacks; (iii) a fault or failure of your computer systems or networks; or (iv)
          any breach by of these Terms by you. <br />
          <br />
          4. <b> &nbsp; PAYMENTS</b>
          <br />
          <br />
          (a) <b>Memberships.</b> For User’s enrolled in Airacer’s membership program, all payments
          shall be automatically drawn by Airacer in accordance with the Payment Frequency set forth
          above. The payments shall be made by either the User or any Payment Responsible Party
          stated above. The Responsible Party shall complete an ACH/Payment Authorization Form
          provided by Airacer. <br />
          <br />
          (b) <b>Membership Cancellations.</b> Unless otherwise specified in this Agreement, and
          effective no earlier than the expiration of the Initial Term End Date, User may cancel
          User’s membership and terminate this Agreement by providing written notice to Airacer.
          Cancellation received between the first and the last day of the month will be effective
          upon the next month’s billing cycle. User shall email such cancellation notice to{' '}
          <a
            href={`mailto:${infoEmail}`}
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
          >
            {infoEmail}
          </a>
          . User’s account must be current and in good standing before Airacer will process any such
          request to cancel. You acknowledge and agree that you will forfeit any prepaid fees made
          prior to the cancellation date. All fees paid are non-refundable. <br />
          <br />
          (c) <b>Payment Default.</b> If User fails to pay any amount owed by User (or Responsible
          Party) fails to pay User’s monthly dues per the Membership Agreement) when due under this
          Agreement, as applicable, then Airacer shall be entitled, at any time in its sole
          discretion, to suspend or cancel User’s membership and terminate this Agreement and to
          require the Responsible Party to immediately pay all past due balances owed. Suspension or
          cancellation shall not relieve the Responsible Party from the obligation to pay any unpaid
          balances owed. Any payments owing to Airacer that are not received when due shall bear
          interest at the highest rate permitted by law. Failure to pay any amounts owed to Airacer
          when due, the responsible party shall pay all costs and expenses of collection incurred by
          Airacer, including reasonable attorney’s fees and expenses. <br />
          <br />
          (d) <b>Payment Information.</b> By entering your payment information on the Services when
          requested, you authorize our third-party payment processor (“<b>Payment Processor</b>”) to
          charge and process the fees and charges assessed in connection with your purchase. We may
          ask you to supply information relevant to your purchase including your credit card number,
          the expiration date of your credit card, and your email and postal addresses for billing
          and notification (such information, “<b>Payment Information</b>”). You represent and
          warrant that you have the legal right to use all payment method(s) represented by any such
          Payment Information. If you pay any amounts with a credit card, we may seek
          pre-authorization of your credit card account prior to your purchase to verify that the
          credit card is valid and has credit available for a transaction. While We take reasonable
          efforts to ensure secure transmission of your information to third parties who assess and
          process payments, We are not responsible for any fees or charges assessed by third parties
          or any errors in the processing of payments by third parties, including any errors that
          result from third-party negligence, improper transmission of payment information, your
          mistaken submission of payment information, or your submission of erroneous payment
          information. The Payment Processor is responsible for transacting such payments through
          its platform, and you agree to release and hold Us harmless from any errors, negligence or
          misconduct by the Payment Processor. You authorize Payment Processor to directly remit Us
          any applicable fees owed to Us. Airacer is not liable for any fees incurred due to billing
          errors. <br />
          <br />
          (e) <b>Pricing Modifications; Promo Codes.</b> We reserve the right to establish, remove,
          and/or revise prices, fees, and/or surcharges for any or all services obtained through the
          use of the Services. We may also, in our sole discretion, make promotional offers with
          different features and different rates to any or all of our customers. Unless made to you,
          these promotional offers will have no bearing on your obligation to pay the amounts
          charged. Airacer may, from time to time in its sole discretion, offer specific promotional
          codes for discounts. Promotional codes are non-transferable and are not redeemable for
          cash, credit, or toward previous purchases. Promotional codes are void where prohibited.
          Any promotional program may be terminated or modified by Us at any time in our sole
          discretion. <br />
          <br />
          5. <b> &nbsp; TERMINATION OR SUSPENSION OF SERVICES</b>
          <br />
          <br />
          Airacer reserves the right to refuse or suspend access to any user, for any reason or no
          reason, and without any notice. Airacer may suspend your use of the Airacer Services or
          any portion thereof if Airacer believes that you have breached these Terms, or for any
          other reason, at its sole discretion. You agree that any termination of your access to the
          Airacer Services may be without prior notice, and you agree that Airacer will not be
          liable to you or any third party for any such termination. Where needed, we reserve the
          right to alert local law enforcement authorities about suspected fraudulent, abusive, or
          illegal activity that may be grounds for termination of your use of the Services. <br />
          <br />
          6. <b> &nbsp; PROHIBITED USES</b>
          <br />
          <br />
          Use of the Services is limited to the permitted uses expressly authorized by us. Any
          violation of this Agreement by your user content, as determined by Airacer in its sole
          discretion, may result in the termination of your access to the Services.{' '}
          <b>The Services shall not be used to:</b> <br />
          <br />
          (a) Harass, abuse, stalk, threaten, defame, or otherwise infringe or violate the rights of
          any other party (including but not limited to rights of publicity or other proprietary
          rights); <br />
          <br />
          (b) Engage in any unlawful, fraudulent, or deceptive activities; <br />
          <br />
          (c) Misrepresent the source, identity, or content of information transmitted via the
          Services; <br />
          <br />
          (d) Use technology or other means to access unauthorized content or non-public spaces;{' '}
          <br />
          <br />
          (e) Use or launch any automated system or process, including without limitation, "bots,"
          "spiders," or "crawlers," to access unauthorized content or non-public spaces; <br />
          <br />
          (f) Attempt to introduce viruses or any other harmful computer code, files or programs
          that interrupt, destroy or limit the functionality of any computer software or hardware or
          telecommunications equipment; <br />
          <br />
          (g) Probe, scan, or test the vulnerability of the Services or any system or network; use
          any robot, spider, scraper or other automated means to access the Services for any purpose
          without our express written permission; <br />
          <br />
          (h) Use the Services in connection with hazardous environments requiring fail-safe
          performance or any application in which the failure or inaccuracy of that application or
          the Services could lead to death, personal injury, or physical or property damage; <br />
          <br />
          (i) Modify the Services in any manner or form; use or develop any application that
          interacts with the Services or provides access to other users' content or information
          without our written permission; or use modified versions of the Services, including to
          obtain unauthorized access to the Services; <br />
          <br />
          (j) Attempt to damage, disable, overburden, or impair our servers or networks; <br />
          <br />
          (k) Attempt to gain unauthorized access to the Services, or any part of it, other
          accounts, computer systems or networks connected to Airacer, or any part of it, through
          hacking, password mining or any other means, or interfere or attempt to interfere with the
          proper working of or any activities conducted on the Services; <br />
          <br />
          (l) Display the Services or profile data on any external display or monitor or in any
          public setting without obtaining the prior consent of all participants. Furthermore, you
          may not display the Services or profile data on any external display or monitor or in any
          public setting in a manner that infringes on the intended use of the Services; <br />
          <br />
          (m) Encourage the commission or encouragement of any illegal purpose, or in violation of
          any local, state, national, or international law, including laws governing criminal acts,
          prohibited or controlled substances, intellectual property and other proprietary rights,
          data protection and privacy, and import or export control; or <br />
          <br />
          (n) violate these Terms in any manner; <br />
          <br />
          7. <b> &nbsp; USE OF LIKENESS</b>
          <br />
          <br />
          You consent to and approve of Airacer’s recording of your image, likeness, name,
          biographic information, personal characteristics, and the royalty free use of this
          information. <br />
          <br />
          You authorize Airacer to edit, alter, copy, exhibit, publish or distribute any photograph,
          audio and/or video using your likeness, image or voice for purposes of publicizing Airacer
          services or for any other related lawful purpose. These include, but are not limited to,
          Airacer’s website, mobile applications, social media, marketing materials, printed and
          digital newsletters videos, advertisements, news releases, and any promotional materials
          in any medium. You waive the right to inspect or approve the finished product, including
          written or electronic copy, wherein your likeness appears. You acknowledge that you will
          not receive any compensation for the use of such images, video, likeness, and waive any
          right to royalties or other compensation arising or related to the use of your likeness.{' '}
          <br />
          <br />
          <b>
            YOU HEREBY HOLD HARMLESS AND RELEASE AND FOREVER DISCHARGE AIRACER, ITS SHAREHOLDERS,
            DIRECTORS, CONTRACTORS, EMPLOYEES, AGENTS AND REPRESENTATIVES FOR ANY AND ALL CLAIMS AND
            DEMANDS ARISING OUT OF OR IN CONNECTION WITH THE USE OF YOUR LIKENESS, IMAGE, VOICE
            AND/OR APPEARANCE, INCLUDING ANY AND ALL CLAIMS FOR INVASION OF PRIVACY, RIGHT OF
            PUBLICITY, MISAPPROPRIATION OR MISUSE OF IMAGE, AND/OR DEFAMATION.
          </b>
          <br />
          <br />
          8. <b> &nbsp; THIRD PARTY SERVICES</b>
          <br />
          <br />
          Airacer does not warrant, endorse, guarantee, or assume responsibility for any product or
          service advertised or offered by a third party through the Services, and Airacer shall not
          be a party to or in any way monitor any transaction between a User and third-party
          providers of products or services. <br />
          <br />
          9. <b> &nbsp; INTELLECTUAL PROPERTY RIGHTS</b>
          <br />
          <br />
          You are granted a non-exclusive, non-transferable, revocable license to access and use the
          Services strictly in accordance with these Terms. As a condition of your use of the
          Services, you warrant to Us that you will not use the Services for any purpose that is
          unlawful or prohibited by these Terms. You may not use the Services in any manner which
          could damage, disable, overburden, or impair the Services or interfere with any other
          party's use and enjoyment of the Services. You may not obtain or attempt to obtain any
          materials or information through any means not intentionally made available or provided
          for through the Services. <br />
          <br />
          All content included as part of the Services, such as text, graphics, videos, logos,
          images, as well as the compilation thereof, and any software used on the Services, is the
          property of Airacer or its suppliers and protected by copyright and other laws that
          protect intellectual property and proprietary rights. You agree to observe and abide by
          all copyright and other proprietary notices, legends or other restrictions contained in
          any such content and will not make any changes thereto. <br />
          <br />
          You will not modify, publish, transmit, reverse engineer, participate in the transfer or
          sale, create derivative works, or in any way exploit any of the content, in whole or in
          part, found on the Services. Our content is not for resale. Your use of the Services does
          not entitle you to make any unauthorized use of any protected content, and in particular
          you will not delete or alter any proprietary rights or attribution notices in any content.
          You will use protected content solely for your personal use and will make no other use of
          the content without the express written permission of Airacer and the copyright owner. You
          agree that you do not acquire any ownership rights in any protected content. We do not
          grant you any licenses, express or implied, to the intellectual property of Airacer or our
          licensors except as expressly authorized by these Terms. <br />
          <br />
          10. <b> &nbsp; DMCA NOTICE AND TAKEDOWN POLICY </b>
          <br />
          <br />
          Airacer respects intellectual property rights and expects its users to do the same. If you
          are a copyright owner or an agent thereof, and you believe that any content hosted on any
          of the Services infringes Your copyrights, then you may submit a notification by providing
          Airacer’ Designated Copyright Agent with the following information in writing: <br />
          <br />
          (a) A physical or electronic signature of a person authorized to act on behalf of the
          owner of an exclusive right that is allegedly infringed; <br />
          <br />
          (b) Identification of the copyrighted work claimed to have been infringed, or if multiple
          copyrighted works on the applicable Services are covered by a single notification, a
          representative list of such works on the applicable Services; <br />
          <br />
          (c) Identification of the material that is claimed to be infringing or to be the subject
          of infringing activity and that is to be removed or access to which is to be disabled, and
          information reasonably sufficient to permit Airacer to locate the material; Information
          reasonably sufficient to permit Airacer to contact the complaining party, such as an
          address, telephone number, and, if available, an electronic mail address at which the
          complaining party may be contacted; <br />
          <br />
          (d) A statement that the complaining party has a good faith belief that use of the
          material in the manner complained of is not authorized by the copyright owner, its agent,
          or the law (for example, "I am under the good faith belief that the use of the copyrighted
          content that is identified herein is not authorized by the copyright owner, its agent, or
          the law."); and <br />
          <br />
          (e) A statement that the information in the notification is accurate, and under penalty of
          perjury, that the complaining party is authorized to act on behalf of the owner of an
          exclusive right that is allegedly infringed (for example, "I swear, under penalty of
          perjury, that the information in this notification is accurate and that I am the copyright
          owner or authorized to act on behalf of the copyright owner, of the copyright(s) that is
          allegedly infringed by the aforementioned content."). <br />
          <br />
          Airacer Designated Copyright Agent to receive notifications of claimed infringement can be
          reached as follows: <br />
          <br />
          <div style={{ marginLeft: '130px' }}>
            <div>Airacer Inc.</div>
            <div>28-07 Jackson Ave</div>
            <div>Long Island City, NY 11101</div>
            <div>Attention: Copyright Claims</div>
          </div>{' '}
          <br />
          For clarity, only notices under this section should go to the Airacer Designated Copyright
          Agent. You acknowledge that if you fail to comply with all of the requirements of this
          Section, your DMCA notice may not be valid. Please note that under Section 512(f) of the
          U.S. Copyright Act, any person who knowingly materially misrepresents that material or
          activity is infringing may be subject to liability. <br />
          <br />
          11. <b> &nbsp; FEEDBACK</b>
          <br />
          <br />
          You can submit questions, comments, suggestions, ideas, original or creative materials or
          other information about Airacer or the Services (collectively, “<b>Feedback</b> ”).
          Feedback is non-confidential and shall become the sole property of Airacer. We shall own
          exclusive rights, including, without limitation, all intellectual property rights, in and
          to such Feedback and shall be entitled to the unrestricted use and dissemination of this
          Feedback for any purpose, commercial or otherwise, without acknowledgment or compensation
          to you. <br />
          <br />
          12. <b> &nbsp; LINKS TO THIRD PARTY WEBSITES/THIRD-PARTY SERVICES</b>
          <br />
          <br />
          The Services may contain links to other brands or services ("<b>Linked Website</b>"). The
          Linked Websites are not under our control and We are not responsible for the contents of
          any Linked Websites, including without limitation any link contained in a Linked Website,
          products or merchandise sold through the Services, or any changes or updates to a Linked
          Website. We are providing these links to you only as a convenience, and the inclusion of
          any link does not imply our endorsement of the services or any association with its
          operators. Certain services made available through the Services are delivered by third
          parties and organizations and these Terms do not apply to any Linked Website. By using any
          product, service or functionality originating from the Services, you hereby acknowledge
          and consent that We may share such information and data with any third party with whom We
          have a contractual relationship to provide the requested product, service or functionality
          on behalf of Airacer and customers. <br />
          <br />
          To the fullest extent permitted by applicable law, you hereby release and forever
          discharge Us (and our officers, employees, agents, successors, and assigns) from, and
          hereby waive and relinquish, each and every past, present and future dispute, claim,
          controversy, demand, right, obligation, liability, action and cause of action of every
          kind and nature (Including personal injuries, emotional distress, identity theft, death,
          and property loss and damage), that has arisen or arises directly or indirectly out of, or
          relates directly or indirectly to, (a) any interactions with, or act or omission of, or
          user content provided by, other Users of the Services or (b) any third-party site,
          products, services, and links Included on or accessed through the Airacer Services. If you
          are a California resident, you hereby waive California civil code section 1542 in
          connection with the foregoing, which states: "a general release does not extend to claims
          which the creditor does not know or suspect to exist in his or her favor at the time of
          executing the release, which if known by him or her must have materially affected his or
          her settlement with the debtor." resolving any disputes. <br />
          <br />
          13. <b> &nbsp; THIRD PARTY ACCOUNT LOGIN </b>
          <br />
          <br />
          In you register with the Services by using your Google, Facebook, Instagram, and other
          related accounts (individually, as a “<b>Third Party Account</b>”) login information, you
          authorize us to access and use certain Third-Party Account information, including, but not
          limited to, any of your Third-Party Account public profile and other information such as
          the profiles of Facebook friends or Instagram followers you might share in common with
          other Users. Please note that if your Third-Party Account or associated service becomes
          unavailable or if our access to such account is terminated by the third-party Host, the
          Third-Party Account content will no longer be available on or through the Services. You
          have the ability to disable the connection between your Account and. Your Third-Party
          Account, at any time. Your relationship with such Third-Party Hosts associated with your
          Third-Party Accounts is governed solely by your Agreement(s) with such Third-Party Hosts.
          We make no effort to review any Third-Party Account content for any purpose, including,
          but not limited to, for accuracy, legality or non-infringement, and We are not responsible
          for any Third-Party Account content. <br />
          <br />
          14. <b> &nbsp; USER CONTENT</b>
          <br />
          <br />
          You may generate content, written or otherwise, while using the Services ("
          <b>User Content</b>"). You acknowledge and agree that your User Content may be used,
          reproduced, displayed, modified, deleted, added to, adapted, and published by us (for
          example, in product marketing campaigns). <br />
          <br />
          You thereby grant Us and its successors a worldwide, irrevocable, transferrable,
          sub-licensable, fully paid, royalty-free, non-exclusive license to use, reproduce,
          display, modify, delete from, add to, adapt, publish, and prepare derivative works from
          your User Content. You further acknowledge and agrees that you and you alone, are
          responsible for the development your User Content. You grant all rights described in this
          paragraph in consideration of our use of the Services and our services, without
          compensation of any sort to you. We do not claim ownership of User Content. <br />
          <br />
          We will not access, view, display or listen to any User Content, except as set forth in
          these Terms and as reasonably necessary to operate the Services, including to monitor your
          conduct and misuse. Actions reasonably necessary to operate the Services may include (but
          are not limited to) (a) advertising, marketing or otherwise promoting the Services; (b)
          responding to support requests and facilitating communication among Users; (c) detecting,
          preventing, or otherwise addressing fraud, security, unlawful, or technical issues; and
          (d) enforcing these Terms. We reserve the right to review, remove, block, or modify any
          content on the Services, including User Content, without notice or further obligation to
          you. <br />
          <br />
          The uploaded User Content must be original material that has been created by the User. By
          uploading content to the Services, you represent and warrant that: (i) you exclusively own
          all right, title, and interest in and to the uploaded User Content; (ii) the uploaded User
          Content does not infringe upon the Intellectual Property Rights of any third party; and
          (iii) there are no legal actions, investigations, claims, or proceedings pending or
          threatened relating to the uploaded User Content. <br />
          <br />
          15. <b> &nbsp; INTERACTIONS WITH OTHER PEOPLE</b>
          <br />
          <br />
          We cannot and do not verify the identity of Users of the Services or the accuracy of any
          information that Users provide. You are solely responsible for determining the identity
          and suitability of the other Users with whom you interact when using the Services. We do
          not investigate or verify any user’s reputation, conduct, morality, criminal background,
          or any information Users may submit to the Services. You are solely responsible for your
          interactions with other Users of the Services. <br />
          <br />
          You agree that in conjunction with your use of the Services, you will maintain safe and
          appropriate contact with other Users and other people in the real world. You will not
          harass threaten or otherwise violate the legal rights of others. You will not trespass, or
          in any manner attempt to gain or gain access to any property or location where you do not
          have a right or permission to be and will not otherwise engage in any activity that may
          result in injury, death, property damage, nuisance, or liability of any kind. If you have
          a dispute with any third party relating to your use of Services, you release Airacer (and
          our officers, directors, agents, subsidiaries, joint ventures, and employees) from all
          claims, demands, and damages (actual and consequential) of every kind and nature, known
          and unknown, suspected, and unsuspected, disclosed and undisclosed, arising out of or in
          any way connected with such disputes. <br />
          <br />
          <b>
            YOU ASSUME ALL RISKS RELATING TO YOUR ONLINE OR OFFLINE COMMUNICATIONS AND INTERACTIONS
            WITH OTHER USERS OF THE SERVICES AND WITH OTHER PERSONS WITH WHOM YOU COMMUNICATE OR
            INTERACT AS A RESULT OF YOUR USE OF THE SERVICES. YOU UNDERSTAND THAT AIRACER DOES NOT
            SCREEN OR INQUIRE INTO THE BACKGROUND OF ANY USERS OF THE SERVICES. AIRACER MAKES NO
            REPRESENTATIONS OR WARRANTIES AS TO THE CONDUCT OF USERS OF THE SERVICES. YOU AGREE TO
            TAKE REASONABLE PRECAUTIONS IN ALL COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF
            THE SERVICES AND WITH OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF
            YOUR USE OF THE SERVICES, PARTICULARLY IF YOU DECIDE TO MEET OFFLINE OR IN PERSON.
          </b>
          <br />
          <br />
          16. <b> &nbsp; ERRORS, INACCURACIES AND OMISSIONS</b>
          <br />
          <br />
          Occasionally there may be information on the Services that may contain typographical
          errors, inaccuracies or omissions that may relate to product or service descriptions,
          pricing, promotions, offers, charges and availability. We reserve the right to correct any
          errors, inaccuracies or omissions, and to change or update information or cancel
          transactions if any information in the Services is inaccurate at any time without prior
          notice. We undertake no obligation to update, amend or clarify information on the
          Services, except as required by law. No specified update or refresh date applied in the
          Services, should be taken to indicate that all information in the Services has been
          modified or updated. <br />
          <br />
          WE DO NOT REPRESENT, WARRANT OR OTHERWISE ENDORSE THAT THE SERVICES OR ANY CONTENT,
          INFORMATION OR SERVICES THAT ARE AVAILABLE OR ADVERTISED OR SOLD THROUGH THE SERVICES ARE
          ACCURATE, COMPLETE, AVAILABLE, CURRENT. WE RESERVE THE RIGHT TO CORRECT ANY ERRORS OR
          OMISSIONS IN THE SERVICES. <br />
          <br />
          17. <b> &nbsp; ELECTRONIC COMMUNICATIONS</b>
          <br />
          <br />
          Using the Services or sending emails to us constitutes electronic communications. If you
          provide Us with your email address to our contact form, you consent to receive electronic
          communications from Us and you agree that all agreements, notices, disclosures and other
          communications that we provide to you electronically, via email and on the Services,
          satisfy any legal requirement that such communications be in writing. <br />
          <br />
          18. <b> &nbsp; INDEMNIFICATION </b>
          <br />
          <br />
          with the exception of AIRACER’S gross negligence and willful misconduct, You agree to
          indemnify, defend and hold harmless AIRACER, its officers, directors, SHAREHOLDERS,
          employees, agents, REPRESENTATIVES, and third parties, for any losses, costs, liabilities
          and expenses (including reasonable attorney's fees) relating to or arising out of your use
          of, or inability to use, the SERVICES, your violation of these Terms or your violation of
          any rights of a third party, or your violation of any APPLICABLE laws, rules or
          regulations. We reserve the right to assume the exclusive defense and control of any
          matter otherwise subject to indemnification by you, in which event you will fully
          cooperate with us in asserting any available defenses. <br />
          <br />
          19. <b> &nbsp; HARM FROM COMMERCIAL USE </b>
          <br />
          <br />
          You agree that the consequences of commercial use or re-publication of content or
          information from the Services may be so serious and incalculable, that monetary
          compensation may not be a sufficient or appropriate remedy and that We will be entitled to
          temporary and permanent injunctive relief to prohibit such use. <br />
          <br />
          20. <b> &nbsp; DISCLAIMERS; NO WARRANTIES </b>
          <br />
          <br />
          EXCEPT AS OTHERWISE SET FORTH HEREIN, THE SERVICES ARE PROVIDED TO YOU STRICTLY ON AN “AS
          IS” AND “AS AVAILABLE” BASIS WITH ALL FAULTS. ALL CONDITIONS, REPRESENTATIONS AND
          WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, WITHOUT
          LIMITATION, ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT, ARE HEREBY DISCLAIMED BY AIRACER TO THE MAXIMUM EXTENT PERMITTED BY
          APPLICABLE LAW. YOU ACKNOWLEDGE AND AGREE THAT THE ENTIRE RISK ARISING OUT OF YOUR USE OF
          THE SERVICES, AND ANY THIRD-PARTY SERVICES OR PRODUCTS REMAINS SOLELY WITH YOU, TO THE
          MAXIMUM EXTENT PERMITTED BY LAW. THE SERVICES MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND
          OTHER ISSUES. YOU ACKNOWLEDGE AND AGREE THAT AIRACER IS NOT RESPONSIBLE FOR ANY DELAYS,
          DELIVERY FAILURES, OR OTHER DAMAGE RESULTING FROM SUCH ISSUES. Certain jurisdictions do
          not allow the exclusion and limitations of certain implied warranties, therefore, some of
          the above exclusions may not apply to you. This Agreement gives Users specific legal
          rights, and Users may also have other rights which vary from state to state. The
          disclaimers and exclusions under this Agreement shall not apply to the extent prohibited
          by applicable law. <br />
          <br />
          21. <b> &nbsp; LIMITATION OF LIABILITY</b>
          <br />
          <br />
          EXCEPT IN CASES OF AIRACER’S GROSS NEGLIGENCE, AIRACER IS NOT RESPONSIBLE OR LIABLE TO YOU
          FOR ANY LOSS, INJURY, EXPENSE, DAMAGE TO PROPERTY OR PERSONAL SICKNESS, INJURY, OR DEATH
          WHICH RESULTS FROM OR DURING A FLIGHT, OR ANY OTHER THIRD-PARTY SERVICE. <br />
          <br />
          NOTWITHSTANDING THE FOREGOING, AIRACER DOES NOT PROVIDE TRANSPORTATION SERVICES AND IS NOT
          A DIRECT AIR CARRIER. AIRACER OFFERS INFORMATION AND A METHOD TO OBTAIN THIRD-PARTY
          TRANSPORTATION SERVICES BUT DOES NOT AND DOES NOT INTEND TO PROVIDE TRANSPORTATION
          SERVICES OR ACT IN ANY WAY AS A TRANSPORTATION CARRIER AND HAS NO RESPONSIBILITY OR
          LIABILITY FOR ANY TRANSPORTATION SERVICES PROVIDED TO USER BY SUCH THIRD PARTIES. AIRACER
          MAY INTRODUCE USERS TO THIRD-PARTY TRANSPORTATION PROVIDERS TO PROVIDE USER
          TRANSPORTATION, BUT AIRACER DOES NOT ASSESS THE SUITABILITY, LEGALITY, OR ABILITY OF ANY
          THIRD-PARTY TRANSPORTATION PROVIDER AND USER EXPRESSLY WAIVES AND RELEASES AIRACER FROM
          ANY AND ALL LIABILITY, CLAIMS, OR DAMAGES ARISING FROM OR IN ANY WAY RELATED TO THE
          THIRD-PARTY TRANSPORTATION PROVIDER. USER ACKNOWLEDGES THAT AIRACER DOES NOT MONITOR ANY
          THIRD-PARTY TRANSPORTATION PROVIDER’S ON-GOING COMPLIANCE WITH ANY AND ALL LICENSING
          AND/OR PERMITTING RULES AND REGULATIONS, AND AIRACER WILL NOT BE RESPONSIBLE FOR ANY
          LIABILITY, CLAIMS, OR DAMAGES ARISING FROM OR IN ANY WAY RELATED TO A THIRD-PARTY
          TRANSPORTATION PROVIDER’S FAILURE TO MAINTAIN A CURRENT LICENSE AND/OR PERMIT.
          RESPONSIBILITY FOR THE DECISIONS USER MAKES REGARDING AIRACER’S SERVICES RESTS SOLELY WITH
          USER. AIRACER WILL NOT ASSESS THE SUITABILITY, LEGALITY, OR ABILITY OF ANY SUCH THIRD
          PARTIES AND USER EXPRESSLY WAIVES AND RELEASES AIRACER FROM ANY AND ALL LIABILITY, CLAIMS,
          CAUSES OF ACTION, OR DAMAGES ARISING FROM USER’S USE OF THE SERVICE, OR IN ANY WAY RELATED
          TO THE THIRD PARTIES INTRODUCED TO USER BY THE SERVICE. IN NO EVENT WILL AIRACER, ITS
          SHAREHOLDERS, DIRECTORS, SUPPLIERS OR LICENSORS BE LIABLE FOR ANY DAMAGES WHATSOEVER,
          WHETHER DIRECT, INDIRECT, GENERAL, SPECIAL, COMPENSATORY, CONSEQUENTIAL, AND/OR
          INCIDENTAL, ARISING OUT OF OR RELATING TO THE CONDUCT OF USER OR ANYONE ELSE IN CONNECTION
          WITH THE USE OF THE SERVICES, INCLUDING WITHOUT LIMITATION, DEATH, BODILY INJURY,
          EMOTIONAL DISTRESS, AND/OR ANY OTHER DAMAGES RESULTING FROM INTERACTIONS WITH OTHER THIRD
          PARTIES, THIRD-PARTY SERVICES, OR FLIGHTS USER BOOKS THROUGH THE SERVICES. <br />
          <br />
          ANY DISPUTE A USER HAS WITH ANY OPERATOR, CARRIER, SERVICE PROVIDER, OR OTHER THIRD PARTY,
          INCLUDING, WITHOUT LIMITATION, ANY OTHER USER OF THE SERVICE, IS DIRECTLY BETWEEN THE USER
          AND SUCH THIRD PARTY AND USER IRREVOCABLY RELEASES AIRACER AND ITS USERS, AFFILIATES,
          AGENTS, SUBSIDIARIES, JOINT VENTURES AND EMPLOYEES) FROM ANY AND ALL CLAIMS, DEMANDS AND
          DAMAGES (ACTUAL AND CONSEQUENTIAL) OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN, ARISING
          OUT OF OR IN ANY WAY CONNECTED WITH SUCH DISPUTES.  AIRACER WILL NOT BE A PARTY TO
          DISPUTES OR NEGOTIATIONS OF DISPUTES BETWEEN USER AND ANY THIRD-PARTY. THE QUALITY OF THE
          FLIGHTS SCHEDULED THROUGH THE SERVICES ARE ENTIRELY THE RESPONSIBILITY OF THE THIRD-PARTY
          PROVIDER WHO ULTIMATELY PROVIDES SUCH FLIGHTS OR THIRD-PARTY SERVICES. USER UNDERSTANDS
          THAT BY USING THE SERVICES, USER MAY BE EXPOSED TO TRANSPORTATION THAT IS POTENTIALLY
          DANGEROUS, HARMFUL, OR OTHERWISE UNSAFE AND THAT USER USES THE SERVICES AT THEIR OWN RISK.{' '}
          <br />
          <br />
          22. <b> &nbsp; INFORMAL DISPUTE RESOLUTION </b>
          <br />
          <br />
          You and Airacer agree that any dispute that has arisen or may arise between Us relating in
          any way to Your use of or access to the Services, any validity, interpretation, breach,
          enforcement, or termination of this Agreement, or otherwise relating to Airacer in any way
          (collectively, "<b>Covered Dispute Matters</b>") will be resolved in accordance with the
          provisions set forth in this Section. <br />
          <br />
          If You have any dispute with Us, you and Airacer agree that before taking any formal
          action, contact us at{' '}
          <a
            href={`mailto:${infoEmail}`}
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
          >
            {infoEmail}
          </a>{' '}
          and provide a brief, written description of the dispute and your contact information
          (including your email address) and allow sixty (60) days to pass, during which We will
          attempt to reach an amicable resolution of any issue with you. <br />
          <br />
          23. <b> &nbsp; MANDATORY ARBITRATION</b>
          <br />
          <br />
          <b>
            By agreeing to the Terms, you agree that you are required to resolve any claim that you
            may have against AIRACER on an individual basis in arbitration, as set forth in this
            Arbitration AGREEMENT. This will preclude you from bringing any class, collective, or
            representative action against AIRACER, and also preclude you from participating in or
            recovering relief under any current or future class, collective, consolidated, or
            representative action brought against AIRACER by someone else.
          </b>
          <br />
          <br />
          (a) <b>Mandatory Arbitration.</b> Please read this dispute resolution carefully (“
          <b>Dispute Resolution</b>”). It affects your rights. YOU AND AIRACER AND EACH OF OUR
          RESPECTIVE SUBSIDIARIES, AFFILIATES, PREDECESSORS IN INTEREST, SUCCESSORS, AND PERMITTED
          ASSIGNS AGREE TO ARBITRATION (EXCEPT FOR MATTERS THAT MAY BE TAKEN TO SMALL CLAIMS COURT),
          AS THE EXCLUSIVE FORM OF DISPUTE RESOLUTION EXCEPT AS PROVIDED FOR BELOW, FOR ALL DISPUTES
          AND CLAIMS ARISING OUT OF OR RELATING TO THIS AGREEMENT OR YOUR USE OF THE SERVICE.
          Arbitration is more informal than a lawsuit in court. Arbitration uses a neutral
          arbitrator instead of a judge or jury, allows for more limited discovery than in court,
          and is subject to very limited review by courts. Arbitrators can award the same damages
          and relief that a court can award. <br />
          <br />
          (b) <b>Procedure.</b> A party who intends to seek arbitration must first send to the
          other, by certified mail, a written notice of intent to arbitrate (a “<b>Notice</b> ”),
          or, in the absence of a mailing address provided by you to Airacer, to you via any other
          method available to Airacer, including via e-mail. The Notice to Airacer should be
          addressed to AIRACER INC. 28-07 Jackson Ave, Long Island City, NY 11101, Attn: General
          Counsel (the “<b>Arbitration Notice Address</b> ”). The Notice must (A) describe the
          nature and basis of the claim or dispute; and (B) set forth the specific relief sought
          (the “<b>Demand</b> ”). If you and Airacer do not reach an agreement to resolve the claim
          within 30 days after the Notice is received, you or Airacer may commence an arbitration
          proceeding as set forth below or file a claim in small claims court. THE ARBITRATION WILL
          BE ADMINISTERED BY THE AMERICAN ARBITRATION ASSOCIATION (“<b>AAA</b> ”) IN ACCORDANCE WITH
          ITS COMMERCIAL ARBITRATION RULES AND THE SUPPLEMENTARY PROCEDURES FOR CONSUMER RELATED
          DISPUTES (the “<b>Rules</b> ”), AS MODIFIED BY THIS AGREEMENT. The Rules and AAA forms are
          available online at{' '}
          <a
            href="https://www.adr.org"
            target="_blank"
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
            rel="noreferrer"
          >
            www.adr.org
          </a>
          . If you are required to pay a filing fee to commence an arbitration against Airacer, then
          Airacer will promptly reimburse you for your confirmed payment of the filing fee upon
          Airacer’s receipt of Notice at the Arbitration Notice Address that you have commenced
          arbitration along with a receipt evidencing payment of the filing fee, unless your Demand
          is equal to or greater than $1,000 or was filed in bad faith, in which case you are solely
          responsible for the payment of the filing fee. <br />
          <br />
          (c) <b>Arbitration Proceeding.</b> The arbitration will be conducted in the English
          language. A single independent and impartial arbitrator will be appointed pursuant to the
          Rules, as modified herein. You and Airacer agree to comply with the following rules, which
          are intended to streamline the dispute resolution process and reduce the costs and burdens
          on the parties: (i) the arbitration will be conducted by telephone, online and/or be
          solely based on written submissions, the specific manner to be chosen by the party
          initiating the arbitration; (ii) the arbitration will not require any personal appearance
          by the parties or witnesses unless otherwise mutually agreed in writing by the parties;
          and (iii) any judgment on the award rendered by the arbitrator may be entered in any court
          of competent jurisdiction. <br />
          <br />
          (d) <b>No Class Actions.</b> YOU AND AIRACER AGREE THAT THE PARTIES MAY BRING CLAIMS
          AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS
          MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. FURTHER, YOU AGREE THAT THE
          ARBITRATOR MAY NOT CONSOLIDATE PROCEEDINGS OF MORE THAN ONE PERSON’S CLAIMS, AND MAY NOT
          OTHERWISE PRESIDE OVER ANY FORM OF A REPRESENTATIVE OR CLASS PROCEEDING, AND THAT IF THIS
          SPECIFIC PARAGRAPH IS FOUND TO BE UNENFORCEABLE, THEN THE ENTIRETY OF THIS MANDATORY
          ARBITRATION SECTION WILL BE NULL AND VOID. <br />
          <br />
          (e) <b>Decision of the Arbitrator.</b> Barring extraordinary circumstances, the arbitrator
          will issue his or her decision within 120 days from the date the arbitrator is appointed.
          The arbitrator may extend this time limit for an additional 30 days in the interests of
          justice. All arbitration proceedings will be closed to the public and confidential and all
          records relating thereto will be permanently sealed, except as necessary to obtain court
          confirmation of the arbitration award. The award of the arbitrator will be in writing and
          will include a statement setting forth the reasons for the disposition of any claim. The
          arbitrator will apply the laws of the State of New York in conducting the arbitration. You
          acknowledge that these terms and your use of the Service evidences a transaction involving
          interstate commerce. The United States Federal Arbitration Act will govern the
          interpretation, enforcement, and proceedings pursuant to the Mandatory Arbitration clause
          in this Agreement. <br />
          <br />
          (f) <b>Equitable Relief.</b> The foregoing provisions of this Dispute Resolution section
          do not apply to any claim in which Airacer seeks equitable relief of any kind. You
          acknowledge that, in the event of a breach of this Agreement by Airacer or any third
          party, the damage or harm, if any, caused to you will not entitle you to seek injunctive
          or other equitable relief against Airacer, and your only remedy will be for monetary
          damages, subject to the limitations of liability set forth in this Agreement. <br />
          <br />
          (g) <b>Claims.</b> You and Airacer agree that, notwithstanding any other rights the party
          may have under law or equity, any cause of action arising out of or related to this
          Agreement, excluding a claim for indemnification, must commence within one year after the
          cause of action accrues. Otherwise, such cause of action is permanently barred. All claims
          you bring against Airacer must be resolved in accordance with this Dispute Resolution
          section. All claims filed or brought contrary to this Dispute Resolution section will be
          considered improperly filed. Should you file a claim contrary to this Dispute Resolution
          section, Airacer may recover attorneys' fees and costs up to $5,000, provided that Airacer
          has notified you in writing of the improperly filed claim, and you have failed to promptly
          withdraw the claim. <br />
          <br />
          (h) <b>Modifications.</b> In the event that Airacer makes any future change to the
          Mandatory Arbitration provision (other than a change to Airacer’s Arbitration Notice
          Address), you may reject any such change by sending us written notice within 30 days of
          the change to Airacer’s Arbitration Notice Address, in which case your account with
          Airacer and your license to use the Service will terminate immediately, and this Dispute
          Resolution provision, as in effect immediately prior to the amendments you reject, will
          survive the termination of this Agreement. <br />
          <br />
          (i) <b>Enforceability.</b> If only Section (d) hereunder or the entirety of this Section
          10 is found to be unenforceable, then the entirety of this Arbitration provision will be
          null and void and, in such case, the parties agree that the exclusive jurisdiction and
          venue described in Section titled “Governing Law” will govern any action arising out of or
          related to this Agreement. <br />
          <br />
          (a) <b>Applicable Law.</b> You and We agree that United States federal law, including the
          Federal Arbitration Act, and (to the extent not Inconsistent with or pre-empted by federal
          law) the laws of the State of New York, without regard to conflict of laws principles,
          will govern all matters subject to arbitration. Such body of law will apply regardless of
          Your residence or the location of where You use the Services. <br />
          <br />
          24. <b> &nbsp; CLASS ACTION WAIVER </b>
          <br />
          <br />
          Any arbitration or action under these Terms will take place on an individual basis; class
          arbitrations and class/representative/collective actions are not permitted. THE PARTIES
          AGREE THAT A PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN THEIR INDIVIDUAL CAPACITY,
          AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PUTATIVE CLASS, COLLECTIVE AND/ OR
          REPRESENTATIVE PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY GENERAL ACTION
          AGAINST THE OTHER. Further, the arbitrator or judge may not consolidate more than one
          person's claims and may not otherwise preside over any form of a representative or class
          proceeding. <br />
          <br />
          25. <b> &nbsp; ENTIRE AGREEMENT</b>
          <br />
          <br />
          Unless otherwise specified herein, this agreement constitutes the entire agreement between
          you and us with respect to the Services and it supersedes all prior or contemporaneous
          communications and proposals, whether electronic, oral or written, between you and us.{' '}
          <br />
          <br />
          26. <b> &nbsp; RELIANCE ON INFORMATION POSTED</b>
          <br />
          <br />
          Commentary and other materials posted on the Services is not intended to amount to advice
          on which reliance should be placed. We therefore disclaim all liability and responsibility
          arising from any reliance placed on such materials by any visitor of the Services, or by
          anyone who may be informed of any of its contents. <br />
          <br />
          27. <b> &nbsp; CHANGES TO TERMS</b>
          <br />
          <br />
          We reserve the right, in our sole discretion, to change the Terms under which the Services
          is offered. The most current version of the Terms will supersede all previous versions. We
          encourage you to periodically review the Terms to stay informed of our updates. We may
          alter or amend our Terms by giving you reasonable notice. By continuing to use the
          Services after expiry of the notice period or accepting the amended Terms (as We may
          decide at our sole discretion), you will be deemed to have accepted any amendment to these
          Terms. <br />
          <br />
          28. <b> &nbsp; Relationship Between the Parties</b>
          <br />
          <br />
          The parties are independent contractors and nothing in these Terms shall be construed as
          making either party the partner, joint venturer, agent, legal representative, employer,
          contractor, or employee of the other. Each Party has sole responsibility for its
          activities and its personnel and shall have no authority and shall not represent to any
          third party that it has the authority to bind or otherwise obligate the other party in any
          manner. <br />
          <br />
          29. <b> &nbsp; SEVERABILITY</b>
          <br />
          <br />
          If any term, clause or provision of these Terms is held invalid or unenforceable, then
          that term, clause or provision will be severable from these Terms and will not affect the
          validity or enforceability of any remaining part of that term, clause or provision, or any
          other term, clause or provision of these Terms. <br />
          <br />
          30. <b> &nbsp; FORCE MAJEURE</b>
          <br />
          <br />
          We shall be excused from performance under these Terms of Use, to the extent We are
          prevented or delayed from performing, in whole or in part, as a result of an event or
          series of events caused by or resulting from: (a) weather conditions or other elements of
          nature or acts of God; (b) acts of war, acts of terrorism, insurrection, riots, civil
          disorders, or rebellion; (c) quarantines or embargoes; (d) labor strikes; (e) error or
          disruption to major computer hardware or networks or software failures; or (g) other
          causes beyond the reasonable control of Airacer. <br />
          <br />
          31. <b> &nbsp; EXPORT CONTROLS</b>
          <br />
          <br />
          The Services originate in the United States and are subject to United States export laws
          and regulations. The Services may not be exported or re-exported by you to certain
          countries or those persons or entities prohibited from receiving exports from the United
          States. In addition, the Services may be subject to the import and export laws of other
          countries. You agree to comply with all United States and foreign laws related to use of
          the Services. <br />
          <br />
          32. <b> &nbsp; NOTICE TO CALIFORNIA RESIDENTS</b>
          <br />
          <br />
          If you are a California resident, under California Civil Code Section 1789.3, you may
          contact the Complaint Assistance Unit of the Division of Consumer Services of the
          California Department of Consumer Affairs in writing at 1625 N. Market Blvd., Suite S-202,
          Sacramento, California 95834, or by telephone at (800) 952-5210 in order to resolve a
          complaint regarding the service or to receive further information regarding use of the
          service. <br />
          <br />
          33. <b> &nbsp; MISCELLANEOUS</b>
          <br />
          <br />
          These Terms constitute the entire agreement between you and Us relating to your access to
          and use of the Services. When you purchase any services from Airacer, The Services are
          controlled and operated from within the United States. Without limiting anything else, We
          make no representation that the Services, information or other materials available on, in,
          or through the Services are applicable or available for use in other locations, and access
          to them from territories where they are illegal is prohibited. Those who choose to access
          our Services from other locations do so on their own volition and are responsible for
          compliance with applicable laws. These Terms, and any rights and licenses granted
          hereunder, may not be transferred or assigned by you without our prior written consent.
          The waiver or failure of Airacer to exercise in any respect any right provided hereunder
          shall not be deemed a waiver of such right in the future or a waiver of any of other
          rights established under these Terms. Headings used in these Terms are for reference only
          and shall not affect the interpretation of these Terms. No person or entity not party to
          this agreement will be deemed to be a third-party beneficiary of these Terms or any
          provision hereof. When used herein, the words “includes” and “including” and their
          syntactical variations shall be deemed followed by the words “without limitation.” <br />
          <br />
          <div>
            <b>CONTACT US</b>
          </div>
          We welcome your questions or comments regarding these Terms: <br />
          <br />
          <b>Airacer Inc.</b> <br />
          <br />
          <b>By Email:</b>
          <br />
          <a
            href={`mailto:${infoEmail}`}
            style={{ textDecoration: 'underline', color: 'rgb(5,99,193)' }}
          >
            {infoEmail}
          </a>
          <br />
          <br />
          <div>
            <div>
              <b>By Mail:</b>
            </div>
            <div>Airacer Inc.</div>
            <div>28-07 Jackson Ave</div>
            <div>Long Island City, NY 11101</div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}
